var _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSmile = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_10213",
    "data-name": "Grupo 10213",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.864,
    height: 27.864,
    viewBox: "0 0 27.864 27.864",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_209",
    "data-name": "Elipse 209",
    cx: 13.932,
    cy: 13.932,
    r: 13.932,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2134",
    "data-name": "Grupo 2134",
    transform: "translate(3.99 8.685)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5382",
    "data-name": "Caminho 5382",
    d: "M268.134,359.948a5.1,5.1,0,0,1-5.089-5.085.789.789,0,0,1,.789-.79h8.6a.789.789,0,0,1,.789.79,5.093,5.093,0,0,1-5.089,5.085Zm-1.516-1.929a3.513,3.513,0,0,0,4.939-2.367S265.658,357.56,266.617,358.02Z",
    transform: "translate(-258.15 -346.804)",
    fill: "#f95e14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5383",
    "data-name": "Caminho 5383",
    d: "M184.234,270.131a.79.79,0,0,1-.789-.79,1.212,1.212,0,0,0-2.424,0,.79.79,0,1,1-1.579,0,2.791,2.791,0,0,1,5.582,0,.789.789,0,0,1-.789.79Z",
    transform: "translate(-179.441 -266.551)",
    fill: "#f95e14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5384",
    "data-name": "Caminho 5384",
    d: "M430.014,270.131a.79.79,0,0,1-.79-.79,1.212,1.212,0,0,0-2.424,0,.789.789,0,1,1-1.579,0,2.791,2.791,0,0,1,5.582,0,.789.789,0,0,1-.789.79Z",
    transform: "translate(-410.831 -266.551)",
    fill: "#f95e14"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSmile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/smile.d57a14a3ba7eff3ebdd659eaf214a4bf.svg";